<template>

    <div class=" d-flex justify-content-center">

        <div class="column col-10 col-mx-auto">
         
                        


            <div class="wrap text-center">
                
            
                <h3 class="entry-title" > Formularz Informacyjny  </h3>  
             
<!-- 
                <div class="info-clause-body" v-dynamic="details"></div>
 -->

            </div>
        </div>



            <!-- Modal -->
            <div  class="modal fade" ref="modal" >
              <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header container dark-bg">
                    <div class="col-auto me-auto ">
                      <h3>Szczegóły</h3>
                    </div>
                      <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body" v-dynamic="details">
                
                    </div>


                    <div class="modal-footer justify-content-center">

                      <button type="button" class="btn btn-lg btn-success" data-bs-dismiss="modal"> Zamknij </button>

                      <!--
                           <b-col lg="4" class="pb-2"><b-button type="button" size="lg" class="btn btn-secondary " data-bs-dismiss="modal">Zamknij</b-button></b-col> -->
                    </div>

                  </div>
              </div>
            </div>
        
    </div>



</template>

<script>

    import { bus } from './main';

        

    export default {
     
       name: 'InfoClauseView',
 

       data(){

            return {

                details: '',

                modal: null

            }
       },


       methods: {



        gotomain(){

            this.$router.push({path: '/'});
        }
       },




        mounted(){


             this.modal = new bootstrap.Modal(this.$refs['modal']);



            setTimeout(()=>{this.modal.show()}, 500);


            // scroll to top with .5s delay
            this.pageTop();

       },

     created() {

           let uri = window.location.href.split('?');

        //console.log(uri);


           if (uri.length > 1 && /amount=[0-9]+/.test(uri[1]) ) {


              let reg = uri[1].match(/amount=([0-9]+)/);

              this.loanAmount = reg[1];
           }


        // initial amount set
        this.setValues(this.loanAmount);


          this.listen('values_set', (data) => {

      //console.log('info val set ' + this.loanAmount)


            this.details = this.getModalContent('info_form');
          });


          this.details = this.getModalContent('info_form');
      }



        
    }
</script>

<style>

.info-clause-body td:first-child {
    background-color: #ededed;
}

.info-clause-body tr {


    border: 1px solid #282828;
}

.info-clause-body td {
    border: inherit;

    }

  .btn-close{
      height:40px;
      justify-content:center;
    }


  .modal-footer button{
    min-width:9rem;
  }




  .modal-dialog {
    max-width: 900px;
  
  }

  .modal-header{
    
    display:flex;

  }

  .modal-title {
    color: #fefefe;
  }

  .modal-body {
    overflow-y: auto;
  }
</style>


// WEBPACK FOOTER //
// src/InfoClauseView.vue